// src/openapi.ts
var ApiKeyType = /* @__PURE__ */ ((ApiKeyType2) => {
  ApiKeyType2["MARKETING"] = "MARKETING";
  ApiKeyType2["PARTNER"] = "PARTNER";
  return ApiKeyType2;
})(ApiKeyType || {});
var REDACTED = "[[redacted]]";
export {
  ApiKeyType,
  REDACTED
};
//# sourceMappingURL=openapi.mjs.map